import { Component, OnInit } from '@angular/core';
import { CommitteeMember } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DevExtremeModule } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from '../../core/core.module';

@Component({
    selector: 'app-calendar-event-dialog',
    templateUrl: './calendar-event-dialog.component.html',
    styleUrls: ['./calendar-event-dialog.component.scss'],
    imports: [DevExtremeModule, SharedModule],
    standalone: true,
})
export class CalendarEventDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    eventId: number;
    calendarEvent: any;
    eventTypes: any;
    eventLocations: any;
    eventDate: Date;
    allDay = false;

    processing = false;
    selectedCommitteeId: number;
    members: any[];
    memberMessage = 'Member list will be generated after Send';
    memberCommitteeLoaded = false;

    constructor(
        public modalRef: BsModalRef,
        private uow: ArkUnitOfWork,
        private appInfo: AppInformationService,
        public auth: AuthService,
        private utility: UtilityService,
    ) {}

    async ngOnInit() {
        this.eventTypes = this.uow.lookups.eventTypes;
        this.eventLocations = this.uow.lookups.eventLocations;
        // console.log(this.eventId)
        const today = new Date();
        if (!this.eventId) {
            this.calendarEvent = this.uow.calendarEvents.createEntity({
                eventDate: this.eventDate ?? moment(today).startOf('day'),
                startTime: this.eventDate ?? new Date(),
                endTime: this.eventDate ? moment(this.eventDate).add(1, 'hours').toDate() : new Date(),
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                privateEvent: false,
            });
        } else {
            this.calendarEvent = await this.uow.calendarEvents.byId(this.eventId);
        }
        await this.getCommitteeMembers();
    }

    allDayChanged(e) {
        console.log(e);
    }

    startTimeChanged(e) {
        this.calendarEvent.endTime = moment(this.calendarEvent.startTime).add(1, 'hours').toDate();
    }

    async getCommitteeMembers() {
        this.appInfo.pleaseWaitShow();
        let members = [];
        if (this.selectedCommitteeId === 1) {
            members = _.uniqBy((await this.uow.getMembersByCommitteeIds([2, 3, 4])) as CommitteeMember[], 'personId');
        } else if (this.selectedCommitteeId === 17) {
            try {
                this.appInfo.pleaseWaitShow();
                // not doing this anymore, members will be found on the server instead
                // this.memberCommitteeLoaded = (await this.utility.getMembersCommitteeMembers()) as any;
                // members = (await this.uow.getMembersByCommitteeIds([this.selectedCommitteeId])) as CommitteeMember[];
                this.appInfo.pleaseWaitHide();
            } catch (error) {
                this.appInfo.pleaseWaitHide();
            }
        } else {
            members = (await this.uow.getMembersByCommitteeIds([this.selectedCommitteeId])) as CommitteeMember[];
        }
        this.members = _.sortBy(members, 'person.lastName');
        this.appInfo.pleaseWaitHide();
    }

    remove() {}

    async save(sendAsText?: boolean) {
        this.processing = true;
        await this.uow.commit();
        this.result.next({ success: true });
    }

    close() {
        this.processing = true;
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
